import { useNavigate } from "react-router-dom";
import { Assessment, Shield, LocalFireDepartment, Whatshot, TrendingUp, AutoGraph, SwapVert } from '@mui/icons-material';

const StatsViewPage = () => {
    const navigate = useNavigate();

    const statsOptions: Array<{
        title: string;
        description: string;
        route: string;
        icon: JSX.Element;
        color: string;
        borderColorHex?: string;
    }> = [
        {
            title: "Rating 2.1 → 3.0 Changes",
            description: "Who rises and who falls under the new rounds-weighted, swing-aware Rating 3.0 (season 32+)",
            route: "/statsview-rating30",
            icon: <AutoGraph className="text-info" style={{ fontSize: 48 }} />,
            color: "border-info"
        },
        {
            title: "Round Swing Leaders",
            description: "Who shifts their team's round-win probability the most — the core Rating 3.0 metric (season 32+)",
            route: "/statsview-swing",
            icon: <SwapVert style={{ fontSize: 48, color: '#a855f7' }} />,
            color: "",
            borderColorHex: "#a855f7"
        },
        {
            title: "Rating 2.0 → 2.1 Changes",
            description: "See which players gained or lost the most when switching from Rating 2.0 to 2.1",
            route: "/statsview-rating21",
            icon: <TrendingUp className="text-success" style={{ fontSize: 48 }} />,
            color: "border-success"
        },
        {
            title: "CT Side Performance",
            description: "Best and worst Counter-Terrorist side performers",
            route: "/statsview-ct",
            icon: <Shield className="text-primary" style={{ fontSize: 48 }} />,
            color: "border-primary"
        },
        {
            title: "T Side Performance",
            description: "Best and worst Terrorist side performers",
            route: "/statsview-t",
            icon: <LocalFireDepartment className="text-warning" style={{ fontSize: 48 }} />,
            color: "border-warning"
        },
        {
            title: "Multi-Kill Masters",
            description: "Players with the most multi-kill rounds and aces",
            route: "/statsview-multi",
            icon: <Whatshot className="text-danger" style={{ fontSize: 48 }} />,
            color: "border-danger"
        }
    ];

    return (
        <div className="container mt-4">
            <div className="row mb-4">
                <div className="col">
                    <h1 className="text-white mb-3 d-flex align-items-center">
                        <Assessment className="me-2" /> Advanced Statistics Analysis
                    </h1>
                    <p className="text-white-50">
                        Deep dive into player performance metrics. Perfect for creating social media content and highlighting exceptional performances.
                    </p>
                </div>
            </div>

            <div className="row g-4">
                {statsOptions.map((option, index) => (
                    <div key={index} className="col-md-6 col-lg-3">
                        <div 
                            className={`card bg-dark text-white h-100 ${option.color} border-2 stats-card`}
                            style={{ cursor: 'pointer', transition: 'transform 0.2s', ...(option.borderColorHex ? { borderColor: option.borderColorHex } : {}) }}
                            onClick={() => navigate(option.route)}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <div className="card-body text-center d-flex flex-column">
                                <div className="mb-3">
                                    {option.icon}
                                </div>
                                <h5 className="card-title">{option.title}</h5>
                                <p className="card-text text-white-50 flex-grow-1">
                                    {option.description}
                                </p>
                                <button className="btn btn-outline-light btn-sm mt-3">
                                    View Analysis →
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row mt-5">
                <div className="col">
                    <div className="alert alert-info">
                        <h5 className="alert-heading d-flex align-items-center">
                            <Assessment className="me-2" /> About Stats Analysis
                        </h5>
                        <hr />
                        <p className="mb-2">
                            These statistical analyses are designed to highlight interesting patterns and exceptional performances in PowerLigaen matches.
                        </p>
                        <ul className="mb-0">
                            <li><strong>Rating 3.0:</strong> See who rises and falls under the new rounds-weighted, swing-aware rating (season 32+)</li>
                            <li><strong>Round Swing:</strong> Find who shifts their team's round-win probability the most — the core of Rating 3.0</li>
                            <li><strong>Rating Changes:</strong> Discover which players benefit most from the advanced Rating 2.1 system</li>
                            <li><strong>Side Performance:</strong> Analyze CT and T side specialists</li>
                            <li><strong>Multi-Kills:</strong> Find the most impactful fraggers</li>
                        </ul>
                        <p className="mb-0 mt-3">
                            <small>Perfect for creating Twitter posts, match previews, and player spotlights!</small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StatsViewPage;